{
  "pt": {
    "lot": {
      "attributes": {
        "end_date": "Data final",
        "internal_note": "Nota interna do lote",
        "land_register": "Registo predial",
        "name": "Nome",
        "start_date": "Data de início",
        "surface": "Área"
      },
      "labels": {
        "lot": "Sem lote | Um lote | {count} Lotes"
      },
      "toasts": {
        "create": "Lote criado",
        "delete": "Lote eliminado",
        "update": "Lote atualizado"
      },
      "validation": {
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)"
      }
    }
  }
}
